import {ControllerFieldState} from "react-hook-form";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import React, {useEffect, useState} from "react";

interface DatePickerWrapperProps {
    enabled: boolean,
    fieldState: ControllerFieldState,
    value: any,
    onChange: any,
    setToday?: boolean
}

// https://reactdatepicker.com/#example-custom-input
export const DatePickerWrapper: React.FC<DatePickerWrapperProps> = ({enabled, fieldState, value, onChange, setToday = false}) => {
    const [startDate, setStartDate] = useState<Date | null>(null);

    useEffect(() => {
        if (value && value !== '' && !setToday) {
            setStartDate(moment(value, 'YYYYMMDD').toDate());
        } else if (value && value !== '' && setToday) {
            setStartDate(new Date());
        }
    }, [value])
    const errorMessage: string | undefined = fieldState.error ? (fieldState.error.message!.length > 0 ? fieldState.error.message : 'Campo obbligatorio.') : undefined;
    return (
        <>
            {/* max-w-[98%] - Per adattare la grandezza del datapicker al 98% dell'elemento padre (col). Per ridimensionarlo correttamente. Vedi LavoratoreFilter.tsx. */}
            <div className="flex-col justify-start h-full">
            <div>
                <DatePicker
                    className={`max-w-[98%] mt-0 w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm ${enabled ? '' : 'bg-gray-200 cursor-not-allowed'}`}
                    dateFormat="dd/MM/yyyy"
                    disabled={!enabled}
                    selected={startDate}
                    //withPortal
                    onChange={(date) => {
                        setStartDate(date)
                        if (date)
                            onChange(moment(date).format('YYYYMMDD'));
                        else
                            onChange('');
                    }}></DatePicker>
            </div>
            {errorMessage && <div className="text-rose-700">{errorMessage}</div>}
            </div>
        </>
    )
}
export default DatePickerWrapper;
/*
() => {
    const [startDate, setStartDate] = useState(new Date());
    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="example-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));
    return (
        <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            customInput={<ExampleCustomInput />}
        />
    );
};*/